import { CombinedTranscript, Speaker } from '@/types/transcript';
import { CallReason } from '../CallList/callReason.enum';

/**
 * Gets the first n phrases spoken by the agent from the transcript
 *
 * @param {Object} params
 * @param {CombinedTranscript[] | null} params.transcript - Combined transcript array
 * @param {number} params.count - Number of phrases to return
 * @returns {string[]}
 */
export const getOpeningPhrases = ({ transcript, count = 2 }: { transcript: CombinedTranscript[] | null; count: number }): string[] => {
    if (!transcript || !Array.isArray(transcript)) return [];

    return transcript
        .filter(segment => segment.speaker === Speaker.AGENT)
        .slice(0, count)
        .map(segment => segment.text);
};

/**
 * Gets the last n phrases spoken by the agent from the transcript
 *
 * @param {Object} params
 * @param {CombinedTranscript[] | null} params.transcript - Combined transcript array
 * @param {number} params.count - Number of phrases to return
 * @returns {string[]}
 */
export const getClosingPhrases = ({ transcript, count = 2 }: { transcript: CombinedTranscript[] | null; count: number }): string[] => {
    if (!transcript || !Array.isArray(transcript)) return [];

    const agentSegments = transcript.filter(segment => segment.speaker === Speaker.AGENT);

    return agentSegments.slice(-count).map(segment => segment.text);
};

/**
 * Maps the call ending reason to a human readable label.
 *
 * @param {string | null} reason - Call ending reason
 * @returns {string}
 */
export const mapCallEndingReasonToLabel = (reason: string | null): string => {
    if (!reason) return 'N/A';

    switch (reason) {
        case CallReason.NOT_SELECTED:
            return 'Not selected';
        case CallReason.DEAL:
            return 'Deal';
        case CallReason.INVALID_NUMBER:
            return 'Invalid number';
        case CallReason.CALLBACK:
            return 'Callback';
        case CallReason.INACTIVE:
            return 'Inactive';
        case CallReason.CONTINUED_CALL:
            return 'Continued call';
        case CallReason.BUSY:
            return 'Busy';
        case CallReason.VOICEMAIL:
            return 'Voicemail';
        case CallReason.REJECTED:
            return 'Rejected';
        default:
            return reason;
    }
};
